import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppSettings } from '../../utils/app-settings';
import { IGetSerpaqResponse } from '../../interfaces/deliveries.interface';

@Injectable({
  providedIn: 'root',
})
export class SerpaqDeliveriesService {
  constructor(private http: HttpClient, private appSettings: AppSettings) {}

  getAll(): Observable<IGetSerpaqResponse> {
    return this.http.get<IGetSerpaqResponse>(this.appSettings.serpaqDeliveries.urls.getAll);
  }

  uploadExcel(file: File, target: 'envio' | 'devolucion' = 'envio'): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    const url = `${this.appSettings.serpaqDeliveries.urls.uploadExcel}?target=${target}`;
    return this.http.post<any>(url, formData);
  }

  loadManual(trackings: string[], target: 'envio' | 'devolucion' = 'envio'): Observable<any> {
    const url = `${this.appSettings.serpaqDeliveries.urls.manual}?target=${target}`;
    return this.http.post<any>(url, { trackings });
  }

  findOne(trackingNumber: string): Observable<any> {
    return this.http.get<any>(this.appSettings.serpaqDeliveries.urls.getOne(trackingNumber));
  }

  // Métodos `setType` y `bulkSetType` removidos: la reclasificación manual
  // entre envíos y devoluciones ya no existe (decisión de producto).

  refreshStatuses(): Observable<any> {
    return this.http.post<any>(this.appSettings.serpaqDeliveries.urls.refresh, {});
  }
}
